import Vue from 'vue'
import qs from 'qs'

// Factory so we can fully reset module state
const getDefaultState = () => ({
  reviewElements: [],
  reviewElement: {},
  formOptions: [],
  reviewElementComment: {}
})

export default ({
  namespaced: true,

  state: getDefaultState(),

  getters: {
    reviewElements: (state) => state.reviewElements,
    reviewElement: (state) => state.reviewElement,
    formOptions: (state) => state.formOptions,
    getReviewElementComment: (state) => state.reviewElementComment
  },

  actions: {
    async loadReviewElementHistory(context, reviewElement) {
      return Vue.axios.get('/api/reviewElement/history/list', {
        params: { reviewElement }
      }).then((res) => res.data)
    },

    loadReviewElements(context, caseId) {
      return Vue.axios.get('/api/reviewElements/load', {
        params: { case: caseId }
      }).then((res) => {
        return context.commit('REVIEW_ELEMENTS', JSON.parse(res.data))
      })
    },

    saveReviewElement(context, reviewElement) {
      const data = qs.stringify(reviewElement)
      return Vue.axios.post('/api/reviewElements/save', data).then((res) => res.data)
    },

    loadFormOptions({ commit }) {
      return Vue.axios.get('/api/reviewElements/formOptions').then((res) => {
        commit('FORM_OPTIONS', res.data)
      })
    },

    setReviewElement(context, reviewElement) {
      context.commit('REVIEW_ELEMENT', reviewElement)
    },

    saveReviewElementComment(context, reviewElementComment) {
      return Vue.axios.post('/api/reviewElement/comment/save', qs.stringify(reviewElementComment)).then((res) => res.data)
    },

    setReviewElementComment(context, reviewElementComment) {
      context.commit('REVIEW_ELEMENT_COMMENT', reviewElementComment)
    },

    // New: allow components to clear this module's state
    clear(context) {
      context.commit('RESET_STATE')
      return Promise.resolve()
    }
  },

  mutations: {
    REVIEW_ELEMENTS(state, reviewElements) {
      state.reviewElements = reviewElements
    },
    FORM_OPTIONS(state, formOptions) {
      state.formOptions = formOptions
    },
    REVIEW_ELEMENT(state, reviewElement) {
      state.reviewElement = reviewElement
    },
    REVIEW_ELEMENT_COMMENT(state, reviewElementComment) {
      state.reviewElementComment = reviewElementComment
    },

    // New: full reset back to initial state (used by actions.clear or direct commit)
    RESET_STATE(state) {
      Object.assign(state, getDefaultState())
    }
  }
})
